const { ShieldCheckIcon, KeyIcon } = require("@heroicons/react/outline");

const teamsData = [
  {
    id: 1,
    title: "Security",
    desc: "Protecting your data at every layer is fundamental to how Slack works.",
    Icon: ShieldCheckIcon,
  },
  {
    id: 2,
    title: "Ennterprice key Management.",
    desc: "Complete control and visibility of access to your data in Slack using your own encryption keys.",
    Icon: KeyIcon,
  },
];

export { teamsData };
